import Client from '../axiosClient'
const resource = '/exchange-rate';
const resourceInit = '/exchange_initialize';
const resourceUpdateStatus = '/exchange_change_status';
// const addRate = '/addRate';
// const updateRate = '/updateRate';

export default {

  post(payload){
    return Client.post(`${resource}`, payload);
  },

  // post(payload) {
  //   return Client.post(`${resource}`, payload);
  // },


  init() {
    return Client.get(`${resourceInit}`);
  },


  get(payload) {
    let filterParam='';
    if(payload) {
      console.log('exchange Repository:',payload);
      // let filterParam = 'requestFrom='+payload['requestFrom'];
      this.filterParam='';//filterParam+`&page=${payload['pageNo']}&pageLength=${payload['pageLength']}`;
      return Client.get(`${resourceInit}?${this.filterParam}`);
    //  return Client.get(`${resource}?page=${payload['pageNo']}&pageLength=${payload['pageLength']}`);
    }
    return Client.get(`${resource}`);

  },


  // get(payload) {
  //   if(payload) {
  //     let dashPartnerId = payload['dashPartnerId'] != undefined ? payload['dashPartnerId'] : "0";
  //     return Client.get(`${resource}?page=${payload['pageNo']}&pageLength=${payload['pageLength']}&dashPartnerId=${dashPartnerId}`);
  //   }
  //   return Client.get(`${resource}`);
  // },

  getById(id) {
    return Client.get(`${resource}/${id}`);
  },

  post(payload) {
    return Client.post(`${resource}`, payload);
  },
  updateStatus(payload) {
    return Client.post(`${resourceUpdateStatus}`, payload);
  },

  /*update(payload, id) {
    return Client.courierAxios.put(`${resource}/${id}`, payload);
  },

  delete(id) {
    return Client.courierAxios.delete(`${resource}/${id}`)
  },*/

  // MANY OTHER ENDPOINT RELATED STUFFS
};



// WEBPACK FOOTER //
// ./src/repositories/events/exchangeRepository.js